document.addEventListener('DOMContentLoaded', function() {
  const iconBlock = document.querySelector('[class*="icon_yjwpem"]');
  const dialogueBlocks = [
    document.querySelector('[class*="text_JbR4C9"]'),
    document.querySelector('[class*="text_ApikB9"]'),
    document.querySelector('[class*="text_6q6XNE"]')
  ].filter(Boolean);
  
  if (!iconBlock || dialogueBlocks.length === 0) return;
  
  // Sauvegarder le contenu HTML original
  const originalContents = dialogueBlocks.map(block => block.innerHTML);
  
  // Masquer les blocs initialement
  dialogueBlocks.forEach(block => {
    block.style.display = 'none';
    block.style.opacity = '0';
  });
  
  let isAnimating = false;
  let currentBlockIndex = 0;
  
  // Fonction pour extraire le texte visible tout en gardant la structure HTML
  function typewriterBlock(block, blockIndex, callback) {
    const htmlContent = originalContents[blockIndex];
    
    // Créer un conteneur temporaire
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    
    // Afficher le bloc
    block.innerHTML = htmlContent;
    block.style.display = 'block';
    setTimeout(() => {
      block.style.opacity = '1';
      block.style.transition = 'opacity 0.4s ease';
    }, 50);
    
    // Récupérer tous les nœuds de texte
    const textNodes = [];
    function getTextNodes(node) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        textNodes.push(node);
      } else {
        node.childNodes.forEach(child => getTextNodes(child));
      }
    }
    getTextNodes(block);
    
    // Sauvegarder le texte original de chaque nœud
    const originalTexts = textNodes.map(node => node.textContent);
    
    // Vider tous les nœuds de texte
    textNodes.forEach(node => node.textContent = '');
    
    let nodeIndex = 0;
    let charIndex = 0;
    
    function typeChar() {
      if (nodeIndex < textNodes.length) {
        const currentNode = textNodes[nodeIndex];
        const fullText = originalTexts[nodeIndex];
        
        if (charIndex < fullText.length) {
          currentNode.textContent += fullText.charAt(charIndex);
          charIndex++;
          setTimeout(typeChar, 20);
        } else {
          // Passer au nœud suivant
          nodeIndex++;
          charIndex = 0;
          setTimeout(typeChar, 50);
        }
      } else {
        if (callback) setTimeout(callback, 600);
      }
    }
    
    typeChar();
  }
  
  // Animation séquentielle des blocs
  function animateNextBlock() {
    if (currentBlockIndex < dialogueBlocks.length) {
      typewriterBlock(dialogueBlocks[currentBlockIndex], currentBlockIndex, function() {
        currentBlockIndex++;
        animateNextBlock();
      });
    } else {
      isAnimating = false;
    }
  }
  
  // Réinitialiser l'animation
  function resetAnimation() {
    dialogueBlocks.forEach(block => {
      block.style.display = 'none';
      block.style.opacity = '0';
    });
  }
  
  // Événement clic sur l'icône
  iconBlock.addEventListener('click', function() {
    if (isAnimating) return;
    
    isAnimating = true;
    currentBlockIndex = 0;
    
    resetAnimation();
    
    // Animation de l'icône
    iconBlock.style.transition = 'transform 0.4s ease';
    iconBlock.style.transform = 'rotate(360deg) scale(1.1)';
    setTimeout(() => {
      iconBlock.style.transform = 'rotate(0deg) scale(1)';
    }, 400);
    
    setTimeout(animateNextBlock, 500);
  });
  
     iconBlock.style.cursor = 'pointer';
  iconBlock.style.transition = 'transform 0.3s ease';
  
  // Aligner l'icône à droite du titre "What's the prompt"
  const titleBlock = document.querySelector('[class*="text_gXMUag"]');
  
  if (iconBlock && titleBlock) {
    const wrapper = document.createElement('div');
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';
    wrapper.style.justifyContent = 'space-between';
    wrapper.style.gap = '16px';
    wrapper.style.width = '100%';
    
    titleBlock.parentNode.insertBefore(wrapper, titleBlock);
    wrapper.appendChild(titleBlock);
    wrapper.appendChild(iconBlock);
    
    titleBlock.style.margin = '0';
    iconBlock.style.margin = '0';
  }
});

